import React, { Component } from 'react'
import { trackSlothOfDeath } from 'lib/utils/errors'
import { trackTimeTillInteractive } from 'lib/utils/stats'
import ErrorBoundary from 'components/ErrorBoundary'
import ErrorPage from 'components/ErrorPage'
import Routes from '../routes'

// Root handles initializing the app.
class Root extends Component {
  render() {
    return (
      <ErrorBoundary errorComponent={ErrorPage} onError={trackSlothOfDeath}>
        <Routes />
      </ErrorBoundary>
    )
  }

  componentDidMount() {
    trackTimeTillInteractive('spa')
  }
}

export default Root
